import KlupplistaManager from '../../../Components/Klupp-Lista/KluppLista';

const KluppLista = () => {
  return (
    <div>
      <KlupplistaManager />
    </div>
  );
};

export default KluppLista;
